import Nullstack from 'nullstack';
export default function IconBrandGoogleAnalytics({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-google-analytics",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "10",
    y: "9",
    width: "4",
    height: "12",
    rx: "1.105"
  }), "   ", Nullstack.element("rect", {
    x: "17",
    y: "3",
    width: "4",
    height: "18",
    rx: "1.105"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "19",
    r: "2"
  }), " ");
}